import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import NavBar from '../components/layout/NavBar'
import { resolveReferralCode } from '../api/referrals'

const REFERRAL_STORAGE_KEY = 'pixeloop_referral_code'

export default function ReferralLanding() {
  const { code = '' } = useParams()
  const navigate = useNavigate()
  const [invalid, setInvalid] = useState(false)
  const [message, setMessage] = useState('Checking invite link…')

  useEffect(() => {
    let mounted = true
    const raw = String(code || '').trim()
    if (!raw) {
      setInvalid(true)
      setMessage('Invite link is invalid or expired.')
      return
    }
    resolveReferralCode(raw)
      .then((res) => {
        if (!mounted || !res?.valid || !res?.code) {
          if (mounted) {
            setInvalid(true)
            setMessage('Invite link is invalid or expired.')
          }
          return
        }
        const canonical = String(res.code).trim()
        try {
          localStorage.setItem(REFERRAL_STORAGE_KEY, canonical)
          sessionStorage.setItem(REFERRAL_STORAGE_KEY, canonical)
        } catch {}
        navigate(`/signup?ref=${encodeURIComponent(canonical)}`, { replace: true })
      })
      .catch(() => {
        if (!mounted) return
        setInvalid(true)
        setMessage('Invite link is invalid or expired.')
      })
    return () => {
      mounted = false
    }
  }, [code, navigate])

  return (
    <div className="min-h-screen">
      <NavBar showSearch={false} />
      <main className="mx-auto max-w-3xl px-4 py-12 text-white">
        <h1 className="text-2xl font-bold">{invalid ? 'Invite link unavailable' : 'Opening your invite…'}</h1>
        <p className="mt-2 text-sm text-white/75">{message}</p>
        {invalid ? (
          <div className="mt-5">
            <Link
              to="/signup"
              className="inline-flex min-h-11 items-center justify-center rounded-lg border border-white/15 bg-white/10 px-4 py-2 text-sm font-semibold text-white hover:bg-white/15"
            >
              Go to signup
            </Link>
          </div>
        ) : null}
      </main>
    </div>
  )
}

